function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutboundWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.49,14.93c-.69,1.13-4.6,5-6.05,5.35L8,24.15A1.19,1.19,0,0,0,9,25.5H23a1.19,1.19,0,0,0,1.07-1.24v-.05l-.42-3.88C22.21,20,18,16.16,17.33,15m9.51-1.59a2.07,2.07,0,0,1-.07.41A17.84,17.84,0,0,1,25.42,16c-.56.86-5.33-1-4.71-2.24a11.87,11.87,0,0,0,1.19-2.15c.07-.45-.52-.82-1-.82-1.43-.12-3.27,0-4.74,0h-.24c-1.5,0-3.31-.12-4.74,0-.52,0-1.11.38-1,.82a11.87,11.87,0,0,0,1.19,2.15c.63,1.17-4.15,3.12-4.71,2.22a17.84,17.84,0,0,1-1.35-2.1,2,2,0,0,1-.07-.41c-.7-3.17,2-6.35,6.05-6.68,1.55-.14,3.11-.2,4.67-.24h.24c1.56,0,3.12.1,4.67.24,4.06.33,6.75,3.51,6.05,6.63Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutboundWhite);
export default __webpack_public_path__ + "static/media/outbound-white.06ad830a.svg";
export { ForwardRef as ReactComponent };